import type { AxiosRequestConfig } from 'axios';
import { api } from '@/lib/api';

/**
 * Baixa mídia de chat SEMPRE pelo proxy autenticado do backend
 * (GET /conversation-messages/download) — o atributo `download` de anchor é
 * ignorado em URL S3 cross-origin, então download direto salvava com o nome
 * da key ({uuid}.pdf) em vez do content.filename.
 *
 * `_handleErrorLocally: true` porque todo caller trata o catch com o próprio
 * toast (mensagem amigável) — sem isso o interceptor global de `api.ts`
 * duplicaria o toast com a mensagem crua do backend.
 */
export async function downloadMediaWithFilename(url: string, filename: string): Promise<void> {
  const config: AxiosRequestConfig & { _handleErrorLocally: boolean } = {
    params: { url, filename },
    responseType: 'blob',
    _handleErrorLocally: true,
  };
  const response = await api.get('conversation-messages/download', config);

  const blob = response.data instanceof Blob ? response.data : new Blob([response.data]);
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}
